import React, {Component} from "react";
import ProgressForm from "./progressForm";

class WebAppDataLoading extends Component {

    onButtonClick = () => {

        const {handleShowWebAppDataLoadingSummary} = this.props;

        handleShowWebAppDataLoadingSummary(false);

    }

    render = () => {

        const {showWebAppDataLoadingSummary, webAppDataLoadingSummary, text} = this.props;

        if (showWebAppDataLoadingSummary === true) {
            return (<React.Fragment>
                    <p>
                        {"Folgende Datensätze wurden vom Server übernommen:"}
                    </p>
                    <table className="table">
                        <thead>
                        <tr>
                            <th>Typ</th>
                            <th>Anzahl</th>
                        </tr>
                        </thead>
                        <tbody>
                        {(webAppDataLoadingSummary.personCount > 0) ?
                            <tr key={"person"}>
                                <td>Personen</td>
                                <td>{webAppDataLoadingSummary.personCount}</td>
                            </tr>
                            : null
                        }
                        {(webAppDataLoadingSummary.absenceCount > 0) ?
                            <tr key={"absence"}>
                                <td>Abwesenheiten</td>
                                <td>{webAppDataLoadingSummary.absenceCount}</td>
                            </tr>
                            : null
                        }
                        {(webAppDataLoadingSummary.projectCount > 0) ?
                            <tr key={"project"}>
                                <td>Projekte</td>
                                <td>{webAppDataLoadingSummary.projectCount}</td>
                            </tr>
                            : null
                        }
                        {(webAppDataLoadingSummary.orderCount > 0) ?
                            <tr key={"order"}>
                                <td>Aufträge</td>
                                <td>{webAppDataLoadingSummary.orderCount}</td>
                            </tr>
                            : null
                        }
                        {(webAppDataLoadingSummary.orderItemCount > 0) ?
                            <tr key={"orderItem"}>
                                <td>Auftragspositionen</td>
                                <td>{webAppDataLoadingSummary.orderItemCount}</td>
                            </tr>
                            : null
                        }
                        {(webAppDataLoadingSummary.costUnitCount > 0) ?
                            <tr key={"costUnit"}>
                                <td>Kostenstellen</td>
                                <td>{webAppDataLoadingSummary.costUnitCount}</td>
                            </tr>
                            : null
                        }
                        {(webAppDataLoadingSummary.machineCount > 0) ?
                            <tr key={"machine"}>
                                <td>Maschinen</td>
                                <td>{webAppDataLoadingSummary.machineCount}</td>
                            </tr>
                            : null
                        }
                        {(webAppDataLoadingSummary.workplaceCount > 0) ?
                            <tr key={"workplace"}>
                                <td>Arbeitsplätze</td>
                                <td>{webAppDataLoadingSummary.workplaceCount}</td>
                            </tr>
                            : null
                        }
                        {(webAppDataLoadingSummary.workprocessCount > 0) ?
                            <tr key={"workprocess"}>
                                <td>Arbeitsgänge</td>
                                <td>{webAppDataLoadingSummary.workprocessCount}</td>
                            </tr>
                            : null
                        }
                        {(webAppDataLoadingSummary.workCombinationCount > 0) ?
                            <tr key={"workCombination"}>
                                <td>Arbeitskombinationen</td>
                                <td>{webAppDataLoadingSummary.workCombinationCount}</td>
                            </tr>
                            : null
                        }
                        </tbody>
                    </table>
                    <button
                        className="btn btn-primary"
                        onClick={this.onButtonClick}>
                        OK
                    </button>
                </React.Fragment>
            );
        } else {
            return (
                <ProgressForm
                    text={"Daten vom Server holen ..."}
                />);
        }
    }
}

export default WebAppDataLoading;
